






import { Component, Vue, Prop } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { Selection } from '../../../stores/modules/selections';

const selection = namespace('selections');

@Component({
  components: {}
})
export default class SelectionButton extends Vue {
  @Prop({ type: Boolean }) disabled!: boolean;
  @Prop({ type: String }) sid!: string;
  @Prop({ type: Object }) selection!: Selection;
  private cartIconAdd: string = 'mdi-cart-plus';
  private cartIconRemove: string = 'mdi-cart-minus';

  @selection.Getter('getById') getById!: (id: string) => Selection;
  @selection.Getter('isSelected') isSelected!: (id: string) => boolean;

  get icon() {
    return this.isSelected(this.sid) ? this.cartIconRemove : this.cartIconAdd;
  }

  @selection.Mutation('addItem') addItem!: (item: Selection) => void;
  @selection.Mutation('removeItem') removeItem!: (item: Selection) => void;

  select(item: Selection) {
    switch (this.isSelected(this.sid)) {
      case true:
        return this.removeItem(item);
      case false:
        return this.addItem(item);
    }
  }

  get iconColor() {
    return this.isSelected(this.sid) ? 'color: green;' : 'color: inherit;';
  }
}
